<div class="manager-list-table">
  <ng-container *ngIf="displayData?.length; else noDataTemplate">
    <emerald-datatable
      [columnDefs]="columnDefs"
      [rowData]="displayData"
      [paginationParams]="paginationParams"
      [customCellTemplate]="{
        managerName: customManagerNameColumn,
      }"
    >
    </emerald-datatable>
  </ng-container>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded">
          <h2 class="empty-state-title">{{ errorMsg }}</h2>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>
  <ng-template #customManagerNameColumn let-level="level" let-eachRow="eachRow">
    <div class="manager-info">
      <span class="name">{{ eachRow?.managerName }}</span>
      <span class="designation">{{ eachRow?.designation }}</span>
    </div>
  </ng-template>
</div>
